<div class="header-container">
    <div class="mobile-view">
        <div class="mobile-container">
            <ccdl-brand
                [mobileSrc]="brandMobileSrc"
                [desktopSrc]="brandDesktopSrc"
                altText="Capvizon"
                [homeRoute]="brandHomeRoute"></ccdl-brand>
            <ccdl-menu-dropdown
                type="hamburger"
                [showDropdown]="true"
                [options]="mobileNavigationMenu"
                (onClick)="selectedOnMobileOption($event)">
                <hr class="dropdown-divider" />
            </ccdl-menu-dropdown>
        </div>
    </div>
    <div class="desktop-view">
        <div class="desktop-container">
            <div class="brand">
                <ccdl-brand
                    [mobileSrc]="brandMobileSrc"
                    [desktopSrc]="brandDesktopSrc"
                    altText="Capvizon"
                    [homeRoute]="brandHomeRoute"></ccdl-brand>
            </div>
            <div class="menu">
                <ccdl-nav-bar [navList]="desktopNavigationMenu"
                    (onNavClick)="selectedOnDesktopNav($event)"></ccdl-nav-bar>
            </div>
            <div class="sign">
                <ccdl-button [btnLabel]="'Sign In'" [btnType]="signInBtnType"
                    (onClick)="signInClick()"></ccdl-button>
                <ccdl-button [btnLabel]="'Sign up'" [btnType]="signUpBtnType"
                    (onClick)="signUpClick()"></ccdl-button>
            </div>
        </div>
    </div>
</div>
